import { createElementBlock as o, openBlock as l, createElementVNode as t } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(s, e) {
  return l(), o("svg", r, e[0] || (e[0] = [
    t("path", {
      fill: "#61DAFB",
      d: "M12.5 14.014a1.783 1.783 0 1 0 0-3.565 1.783 1.783 0 0 0 0 3.565"
    }, null, -1),
    t("path", {
      stroke: "#61DAFB",
      "stroke-width": ".87",
      d: "M12.5 15.884c5.283 0 9.565-1.635 9.565-3.652S17.783 8.58 12.5 8.58s-9.565 1.635-9.565 3.652 4.282 3.652 9.565 3.652Z"
    }, null, -1),
    t("path", {
      stroke: "#61DAFB",
      "stroke-width": ".87",
      d: "M9.337 14.058c2.642 4.575 6.199 7.466 7.946 6.457 1.746-1.008 1.021-5.534-1.62-10.11C13.02 5.832 9.464 2.94 7.717 3.949s-1.021 5.535 1.62 10.11Z"
    }, null, -1),
    t("path", {
      stroke: "#61DAFB",
      "stroke-width": ".87",
      d: "M9.337 10.406c-2.641 4.575-3.366 9.1-1.62 10.11 1.747 1.008 5.304-1.883 7.946-6.458s3.366-9.101 1.62-10.11c-1.747-1.009-5.305 1.883-7.946 6.458Z"
    }, null, -1)
  ]));
}
const c = { render: n };
export {
  c as default,
  n as render
};
